import { useCallback, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import search from '~/assets/icons/search.svg';
import user from '~/assets/icons/user.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { TextInput } from '~/components/ui/TextInput';
import { IPlayerSearchResult } from '~/rage';
import {
	StyledContainer,
	StyledIcon,
	StyledResultsContainer,
	StyledSelectItem,
	StyledSelectItemWrapper,
} from './PlayerInput.styled';

interface IPlayerInputProps {
	value: string;
	items: IPlayerSearchResult[];
	onChange: (value: string) => void;
}

const PlayerInput: React.FC<IPlayerInputProps> = ({
	value,
	onChange,
	items,
}: IPlayerInputProps) => {
	const [resultsVisible, setResultsVisibile] = useState<boolean>(false);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const value = e.target.value;
			onChange(value);
		},
		[onChange],
	);

	const handleSelect = useCallback((item: IPlayerSearchResult) => {
		onChange(item.nickname);
		setResultsVisibile(false);
	}, []);

	return (
		<StyledContainer>
			<TextInput
				height={50}
				fontSize={14}
				placeholder={'Введите имя игрока'}
				value={value}
				onChange={handleChange}
				onFocus={() => setResultsVisibile(true)}
				onBlur={() => setResultsVisibile(false)}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
				tabIndex={-1}
				style={{ padding: '0 54px 0 20px' }}
			/>
			<StyledIcon src={search} />
			<CSSTransition
				in={resultsVisible}
				classNames={'results'}
				timeout={500}
				unmountOnExit
			>
				<StyledResultsContainer tabIndex={-1}>
					<StyledSelectItemWrapper $disabled={true}>
						<StyledSelectItem>
							<img
								src={search}
								style={{ filter: 'invert(100%)', pointerEvents: 'none' }}
							/>
							<Text style={{ fontSize: '16px', fontWeight: 500 }}>
								Результаты поиска
							</Text>
						</StyledSelectItem>
					</StyledSelectItemWrapper>
					{items.map((item, index) => (
						<StyledSelectItemWrapper
							key={index}
							onClick={() => handleSelect(item)}
							onMouseEnter={() => playSound(Sound.LinkCursor)}
						>
							<StyledSelectItem>
								<img src={user} style={{ pointerEvents: 'none' }} />
								<Text style={{ fontSize: '16px', fontWeight: 400 }}>
									{item.nickname}
								</Text>
								<Text style={{ fontSize: '16px', fontWeight: 400 }}>
									Выбрать игрока
								</Text>
							</StyledSelectItem>
						</StyledSelectItemWrapper>
					))}
				</StyledResultsContainer>
			</CSSTransition>
		</StyledContainer>
	);
};

export { PlayerInput };
